@if (callState) {
<onsip-call [callUuid]="callState.uuid"> </onsip-call>
}
<!-- the call page divider is part of the call page, but the incoming call divider is part of the conversations component it's dumb as shit i know -->
@if (!callState || !callState.videoAvailable) {
<mat-divider onsip-dotted-divider></mat-divider>
} @if (!!callState) {
<onsip-hubspot-embed [callState]="callState"> </onsip-hubspot-embed>
}
